module.exports = __webpack_public_path__ + "img/eVisax200W.93bb1473.png";